import { registerView, ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import * as React from "react";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import { Col, Form } from "react-bootstrap";
import { DataTestIds } from "../../../../data-test-constants";
import ReactMarkdown from "react-markdown";
import TermsAgreementViewModel from "../../../../viewModels/eshop/order/components/termAgreementViewModel";
import { Check } from "@frui.ts/bootstrap";
import { useEffect } from "react";

const TermAgreementView: ViewComponent<TermsAgreementViewModel> = observer(({ vm }) => {
  const isIPhoneChrome = () => {
    const ua = navigator.userAgent;
    return /iPhone/i.test(ua) && /CriOS/i.test(ua);
  };

  useEffect(() => {
    if (!isIPhoneChrome()) return;

    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload();
      }
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  return (
    <>
      <Form.Row className="mt-4">
        <Form.Group as={Col}>
          <Check
            autoComplete="off"
            checked={vm.chargeOrder._termsAgreement}
            onChange={e => (vm.chargeOrder._termsAgreement = e.target.checked)}
            data-testid={DataTestIds.TERMS_AND_CONDITIONS_CHECK}
            custom
            target={vm.chargeOrder}
            threeState={true}
            property="_termsAgreement"
            label={
              <ReactMarkdown
                className="markdown"
                linkTarget="_blank"
                components={{ a: ({ node, ...props }) => <a {...props} /> }}>
                {vm.translateTermsAgreement}
              </ReactMarkdown>
            }
          />
        </Form.Group>
      </Form.Row>
      {vm.termAgreementError && (
        <div className="d-flex justify-content-center bg-danger-light py-0 p-2 font-size-sm font-weight-bold text-danger">
          <Icon className="mr-2" icon={IconType.InvertedError} height={18} width={18} />
          <span>{vm.translateGeneral("alertTermsAgreement")}</span>
        </div>
      )}
    </>
  );
});

registerView(TermAgreementView, TermsAgreementViewModel);
